module.exports = __webpack_public_path__ + "assets/media/client-2.b4f6a77e.svg";